import type { UserFeatures } from '../models/UserFeatures.d.ts';

export function hasSearchLimit(userFeatures: UserFeatures): boolean {
  return userFeatures.searches > 0 || userFeatures.extra_searches > 0;
}
